<template>
    <div>
        <Header :headerData="headerData"></Header>

        <div class="query_box" >
            <a-select
                v-if="userInfo.tenant_id == 1"
                class="query_field"
                v-model:value="searchForm.tenant_id"
                :placeholder="t('account.tenant')"
                :options="searchTenantOptions"
                @change="handleSelectChange('tenant')"
            ></a-select>
            <a-input
                class="query_field"
                v-model:value="searchForm.email"
                :placeholder="t('account.backendAccountEmail')"
                @change="handleInputChange()"
            />
            <a-button type="primary" size="small" style="margin-right:.625rem" @click="handleSearch">
                <img src="@/assets/image/search.png" alt="" width="15" style="margin-right: .3125rem;margin-top:-0.1875rem">
                {{ $t('base.search') }}
            </a-button>
        </div>

         <div class="operate_btn">
            <a-button type="primary" size="small" style="margin-right:.625rem;margin-bottom:.625rem" @click="handle('createAccount')">
                <img src="@/assets/image/addAccount.png" alt="" width="15" style="margin-right: .3125rem;margin-top:-0.1875rem">
                {{ $t('account.createAddAccount') }}
            </a-button>
            <a-button v-if="userInfo.tenant_id == 1 && (userInfo.role.split(',').includes(roleSupperAuth) || userInfo.role.split(',').includes(roleAdminAuth))" type="primary" size="small" style="margin-right:.625rem;margin-bottom:.625rem" @click="handle('invitationRegistration')">
                <img src="@/assets/image/addAccount.png" alt="" width="15" style="margin-right: .3125rem;margin-top:-0.1875rem">
                {{ $t('account.invitationRegistration') }}
            </a-button>
        </div>

        <div>
            <Table
                class="table"
                :table="table"
                @handleChangePagination="handleChangePagination"
            >
                <!-- <template v-slot:customCol="{props}"></template> -->
                <!-- 父表格操作按钮 -->
                <template v-slot:tableAction="{props}">
                    <template v-if="props.column.key === 'email'">
                        {{ props.record.email }}
                        <EyeInvisibleOutlined v-if="props.record.show_sensitive_email && props.record.email !== '-'" style="float:right;margin-top:.25rem" @click="handle('showSensitiveData', props.record, 'email')"/>
                        <EyeOutlined v-if="!props.record.show_sensitive_email && props.record.email !== '-'" style="float:right;margin-top:.25rem" @click="handle('hideSensitiveData', props.record, 'email')"/>
                    </template>
                    <template v-if="props.column.key === 'auth_email'">
                        {{ props.record.auth_email }}
                        <EyeInvisibleOutlined v-if="props.record.show_sensitive_auth_email && props.record.auth_email !== '-'" style="float:right;margin-top:.25rem" @click="handle('showSensitiveData', props.record, 'auth_email')"/>
                        <EyeOutlined v-if="!props.record.show_sensitive_auth_email && props.record.auth_email !== '-'" style="float:right;margin-top:.25rem" @click="handle('hideSensitiveData', props.record, 'auth_email')"/>
                    </template>
                    <template v-if="props.column.key === 'role_names'">
                        <div v-for="(item,index) in props.record.role_names" :key="index" style="margin: .125rem 0;">
                            <a-tag >{{ item }}</a-tag>
                        </div>
                    </template>
                    <template v-if="props.column.key === 'action'">
                        <a-button type="primary" size="small" style="margin-right:.625rem" v-if="userHasAssignRoleAuth" @click="handle('editAuth',props.record)">
                            {{ $t('account.auth') }}
                        </a-button>
                        <a-button size="small" style="margin-right:.625rem" v-if="userHasAssignRoleAuth" @click="handle('authDetail',props.record)">
                            {{ $t('account.authDetail') }}
                        </a-button>
                        <a-dropdown>
                            <template #overlay>
                                <a-menu @click="handleMenuClick">
                                    <a-menu-item key="1" :disabled="props.record.status_val == 2" @click="handle('diasbleAccount', props.record)">
                                        {{ $t('account.diasbleAccount') }}
                                    </a-menu-item>
                                    <a-menu-item key="2" :disabled="props.record.status_val == 0"  @click="handle('activateAccount', props.record)">
                                        {{ $t('account.activateAccount') }}
                                    </a-menu-item>
                                </a-menu>
                            </template>
                            <a-button size="small" style="margin-right:.625rem">
                                {{ $t('account.diasbleActivate') }} <DownOutlined />
                            </a-button>
                        </a-dropdown>
                        <a-tooltip placement="topLeft">
                            <template #title>
                                <span>{{ $t('account.resendEmailTip') }}</span>
                            </template>
                            <a-button size="small" style="margin-right:0rem" :disabled="props.record.status_val !== 1" @click="handle('resendEmail',props.record)">
                                {{ $t('account.resendEmail') }}
                            </a-button>
                        </a-tooltip>
                        
                    </template>
                </template>

                <!-- 子表格操作按钮 -->
                <template v-slot:childTableAction="{props}">
                    <template v-if="props.column.key === 'action'">
                        <a-button type="primary" ghost size="small" :disabled="props.record.disabled" @click="handle('deletePart',props.record)">{{$t('access.deletePart')}}</a-button>
                    </template>
                </template>
            </Table>    
        </div>

        <!-- 创建账号 -->
        <a-modal 
            v-model:open="visible"
            :closable="false"
            :maskClosable="false"
            :width="650"
            centered
            :footer="null"
        >
            <div class="back" @click="back">
                <LeftOutlined />
                {{ $t('account.back') }}
            </div>

            <div class="form">
                <div class="form_item">
                    <div class="form_item_label">{{ $t('account.emailAddr') }} <span class="required">*</span> </div>
                    <div>
                        <a-input 
                            v-model:value="formData.email"
                            :maxlength="35"
                            allowClear
                            @blur="handleBlur"
                            @change="changeInput"
                        />
                    </div>
                </div>
                <div class="form_item form_item_flex">
                    <div class="form_item_left" :style="{marginRight: userInfo.tenant_id == 1 ? 'px' : '.625rem'}">
                        <div class="form_item_label">{{ $t('account.accountType') }} <span class="required">*</span> </div>
                        <div>
                            <a-select
                                v-model:value="formData.category"
                                style="width: 100%"
                                :options="accountTypeOptions"
                                @change="(val)=>handleChange(val, 'category')"
                            ></a-select>
                        </div>
                    </div>
                    <div v-if="userInfo.tenant_id == 1" class="form_item_right">
                        <div class="form_item_label">{{ $t('account.tenant') }} <span class="required">*</span> </div>
                        <div>
                            <a-select
                                v-model:value="formData.tenant_id"
                                style="width: 100%"
                                :disabled="user_category2.length === 0"
                                :options="tenantOptions"
                                @change="handleChange"
                            ></a-select>
                        </div>
                    </div>
                </div>
                <div class="form_item form_item_flex">
                    <div class="form_item_left">
                        <div class="form_item_label">{{ $t('account.firstName') }} <span class="required">*</span> </div>
                        <div>
                            <a-input 
                                v-model:value="formData.first_name"
                                :maxlength="35"
                                style="width: 100%"
                                :disabled="form_disabled"
                            />
                        </div>
                    </div>
                    <div class="form_item_right">
                        <div class="form_item_label">{{ $t('account.lastName') }} <span class="required">*</span> </div>
                        <div>
                            <a-input 
                                v-model:value="formData.last_name" 
                                :maxlength="25"
                                style="width: 100%"
                                :disabled="form_disabled"
                            />
                        </div>
                    </div>
                </div>
                <div class="form_item form_item_flex">
                    <div class="form_item_left">
                        <div class="form_item_label">{{ $t('account.companyName') }} <span class="required">*</span> </div>
                        <div>
                            <a-input 
                                v-model:value="formData.company"
                                :maxlength="30"
                                style="width: 100%"
                                :disabled="form_disabled"
                            />
                        </div>
                    </div>
                    <div class="form_item_right">
                        <div class="form_item_label">{{ $t('account.telephone') }} <span class="required">*</span> </div>
                        <div>
                            <a-input-number 
                                v-model:value="formData.mobile" 
                                :maxlength="16"
                                :disabled="form_disabled"
                                :controls="false"
                                style="width: 100%"
                            />
                        </div>
                    </div>
                </div>
                <div class="form_item">
                    <div class="form_item_label">{{ $t('account.password') }} <span class="required">*</span> </div>
                    <div>
                        <a-input-password 
                            v-model:value="formData.password" 
                            :disabled="form_disabled"
                            :maxlength="16"
                        />
                    </div>
                </div>
                <div class="form_item">
                    <div class="form_item_label">{{ $t('account.confirmPsw') }} <span class="required">*</span> </div>
                    <div>
                        <a-input-password 
                            v-model:value="formData.confirm_password" 
                            :disabled="form_disabled"
                            :maxlength="16"
                        />
                    </div>
                </div>
                <div v-if="userInfo.tenant_id == 1 && user_category.length > 0 && formData.category == 3" class="form_item" style="margin:1.25rem 0 1.875rem;">
                    <div>
                        <a-checkbox v-model:checked="formData.tenant_admin">{{ $t('account.tenantAdmin') }}</a-checkbox>
                    </div>
                </div>

                <div class="createBtnDiv">
                    <a-button type="primary" :loading="confirmLoading" class="createBtn" @click="createAccount">
                        {{ $t('account.create') }}
                    </a-button>
                </div>

                <ol class="createTip">
                    <div class="tip_title">
                        <img src="@/assets/image/info.svg" alt="" width="20" class="tip_img"> 
                        {{ $t('account.notice') }}
                    </div>
                    <li class="tip_text">{{ $t('account.createTip1') }}</li>
                    <li class="tip_text">{{ $t('account.createTip2') }}</li>
                </ol>
            </div>
        </a-modal>
        <!-- 邀请注册 -->
        <a-modal 
            v-model:open="invitationVisible"
            :closable="false"
            :maskClosable="false"
            :width="650"
            centered
            :footer="null"
        >
            <div class="back" @click="invitationBack">
                <LeftOutlined />
                {{ $t('account.back') }}
            </div>

            <div class="form">
                <div class="form_item">
                    <div class="form_item_label">{{ $t('account.emailAddr') }} <span class="required">*</span> </div>
                    <div>
                        <a-textarea 
                            v-model:value="invitateFormData.email"
                            :maxlength="200"
                            allowClear
                            @blur="handleBatchEmailBlur"
                        />
                        <!-- <a-input 
                            v-model:value="formData.email"
                            :maxlength="35"
                            allowClear
                            @blur="handleBlur"
                            @change="changeInput"
                        /> -->
                    </div>
                    
                </div>
                <div class="form_item">
                    <div class="form_item_label">{{ $t('access.language') }} </div>
                    <a-select
                            ref="select"
                            v-model:value="invitateFormData.lang"
                            style="width: 100%"
                            :options="langOptions"
                        ></a-select>
                </div>
                

                <div class="createBtnDiv">
                    <a-button type="primary" :loading="invitateConfirmLoading" class="createBtn" @click="invitationRegistration">
                        {{ $t('login.send') }}
                    </a-button>
                </div>
            </div>
        </a-modal>

        <a-modal 
            v-model:open="createTipVisible"
            :title="null"
            :width="650"
            centered
            :closable="false"
            :destroyOnClose="true"
            :maskClosable="false"
            :footer="null"
            @ok="createTipVisible = false"
        >
            <div class="createSuccessTip">
                <div class="tip_title">
                    <img src="@/assets/image/info.svg" alt="" width="20" class="tip_img"> 
                    {{ $t('base.tip') }}
                </div>
                <div class="tip_text">{{ $t('account.createTip3') }}</div>
                <div class="tip_text">{{ $t('account.createTip4') }}</div>
                <ul>
                    <li class="tip_text">{{ $t('account.createTip5') }}</li>
                    <li class="tip_text">{{ $t('account.createTip6') }}  <span style="font-weight: 700;">service@gobao-ebike.com</span> {{ $t('account.createTip7') }}</li>
                </ul>
            </div>
            <div style="text-align: center;">
                <a-button type="primary" @click="createTipVisible = false">{{ $t('base.ok') }}</a-button>
            </div>
            
        </a-modal>

        <a-modal 
            v-model:open="batchTipVisible"
            :title="null"
            :width="650"
            centered
            :closable="false"
            :destroyOnClose="true"
            :maskClosable="false"
            :footer="null"
            @ok="batchTipVisible = false"
        >
            <div class="createSuccessTip">
                <div>{{$t('account.sendInvitationTotal')}}: {{ invitationTotal }}</div>
                <div>{{$t('access.success')}}:  <span style="color:green">{{ invitationSuccess }}</span> </div>
                <div>{{$t('access.failed')}}:  <span style="color:red">{{ invitationFailed }}</span> </div>
                <Table
                    v-if="invitationFailed > 0"
                    class="table"
                    :table="batchSendEmailTable"
                >
                </Table> 
                <!-- <div v-if="invitationSuccess !== 0">
                    <div class="tip_title">
                        <img src="@/assets/image/info.svg" alt="" width="20" class="tip_img"> 
                        {{ $t('base.tip') }}
                    </div>
                    <div class="tip_text">{{ $t('account.createTip3') }}</div>
                    <div class="tip_text">{{ $t('account.createTip4') }}</div>
                    <ul>
                        <li class="tip_text">{{ $t('account.createTip5') }}</li>
                        <li class="tip_text">{{ $t('account.createTip6') }}  <span style="font-weight: 700;">service@gobao-ebike.com</span> {{ $t('account.createTip7') }}</li>
                    </ul>
                </div> -->
            </div>
            <div style="text-align: center;">
                <a-button type="primary" @click="batchTipVisible = false">{{ $t('base.ok') }}</a-button>
            </div>
            
        </a-modal>

        <!-- 授权 -->
        <a-modal 
            v-model:open="authVisible"
            :title="t('account.auth')"
            :closable="false"
            :width="650"
            centered
            :maskClosable="false"
            :okText="t('base.ok')"
            :cancelText="t('base.cancel')"
            @ok="bindRole"
            @cancel="authVisible = false"
        >
            <a-tree
                v-model:expandedKeys="expandedKeys"
                v-model:selectedKeys="selectedKeys"
                v-model:checkedKeys="checkedKeys"
                checkable
                :selectable="true"
                :tree-data="treeData"
                @check="handleMenuTreeCheck"
            ></a-tree>
        </a-modal>

        <!-- 授权详情 -->
        <a-modal 
            v-model:open="authDetailVisible"
            :title="t('account.userAuthorizedFunc')"
            :width="650"
            :maskClosable="false"
            :footer="null"
        >
            <a-card style="width: 100%">
                <div v-if="user_auth_label.length > 0">
                    <a-tag 
                        v-for="item in user_auth_label" 
                        :key="item" 
                        color="purple"
                        style="margin: .125rem;"
                    >{{ item }}</a-tag>
                </div>
                <a-empty v-else />
            </a-card>
        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, nextTick, watch} from "vue";
    import Table from "@/components/Table.vue";
    import Card from "@/components/Card.vue";
    import Header from "@/layouts/component/Header.vue";
    import { useRoute, useRouter } from "vue-router";
    import { useI18n } from 'vue-i18n';
    import { message, Modal, notification } from 'ant-design-vue';
    import { getWeek } from '@/hooks/useGetWeek';
    import { getLastWeekDate, getFieldVal, debounce } from '@/utils/global';
    import { AccountApi } from '@/api/AccountApi.js';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';
    import { RoleApi } from '@/api/RoleApi.js';
    import { LoginApi } from '@/api/LoginApi.js';


    const route = useRoute()
    const router = useRouter()
    const { t } = useI18n()

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const visible = ref(false)
    const invitationVisible = ref(false)
    const authVisible = ref(false)
    const authDetailVisible = ref(false)
    const createTipVisible = ref(false)
    const batchTipVisible = ref(false)
    const rowData = ref(null)
    const form_disabled = ref(false)
    const confirmLoading = ref(false)
    const invitateConfirmLoading = ref(false)
    const operateType = ref('add')
    const role_ids = ref([])
    const user_auth_label = ref([])
    const user_category = ref([])
    const user_category2 = ref([])
    const sys_role_arr = ref([])

    const searchForm = reactive({
        tenant_id: null,
        email:'',
    })
    const treeData = ref([])
    const expandedKeys = ref([])
    const selectedKeys = ref([])
    const checkedKeys = ref([])
    const roleSupperAuth = import.meta.env.VITE_BASE_URL.trim() == 'https://sit.gobao-ebike.com' ? '252':(import.meta.env.VITE_BASE_URL.trim() == 'https://open.gobao-ebike.com' ? '38':'')
    const roleAdminAuth = import.meta.env.VITE_BASE_URL.trim() == 'https://sit.gobao-ebike.com' ? '264':(import.meta.env.VITE_BASE_URL.trim() == 'https://open.gobao-ebike.com' ? '40':'')
    const userHasAssignRoleAuth = ref(false)

    const headerData = ref({
        menu:'menu.AccountMTG',
        menu_desc: 'menu.subAccountMTG',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    const formData = reactive({
        email:'',
        first_name:'',
        last_name:'',
        company:'',
        mobile:'',
        category:'',
        tenant_id:'',
        tenant_admin:false,
        password:'',
        confirm_password:'',
    })
    const invitateFormData = reactive({
        email: '',
        lang: 'en_US'
    })

    const langOptions = ref([])

    const accountTypeOptions = ref([
        {
            label: t('account.contractManufacturer'),
            value: 2,
        },
        {
            label: t('account.ordinaryBackEndAccount'),
            value: 3,
        }
    ])

    const tenantOptions = ref([])
    const searchTenantOptions = ref([])
    const tenantObj = reactive({})
    const invitationTotal = ref(0)
    const invitationSuccess = ref(0)
    const invitationFailed = ref(0)

    const table = ref({
        data: [],
        columns: [
            {
                title: t('account.backendAccountEmail'),
                dataIndex: 'email',
                key: 'email',
                width: 180,
                resizable: true,
                fixed: 'left',
                customFilterDropdown: true,
                onFilter: (value, record) => record.email.toString().toLowerCase().includes(value.toLowerCase()),
                onFilterDropdownOpenChange: visible => {
                    if (visible) {
                        setTimeout(() => {
                            searchInput.value.focus();
                        }, 100);
                    }
                },
            },
            {
                title: t('account.registrationDate'),
                dataIndex: 'create_time',
                key: 'create_time',
                width: 120,
                resizable: true,
            },
            {
                title: t('account.authorizerEmail'),
                dataIndex: 'auth_email',
                key: 'auth_email',
                width: 180,
                resizable: true,
            },
            {
                title: t('account.category'),
                dataIndex: 'category',
                key: 'category',
                width: 160,
                resizable: true,
                filters: [
                    {
                        text: t('account.ordinaryBackEndAccount'),
                        value: 'Standard backend account',
                    },
                    {
                        text: t('account.contractManufacturer'),
                        value: 'Assembly account',
                    },
                ],
                filterMultiple: false,
                onFilter: (value, record) => record.category.indexOf(value) === 0,
            },
            {
                title: t('account.status'),
                dataIndex: 'status',
                key: 'status',
                width: 100,
                resizable: true,
                filters: [
                    {
                        text: t('account.normal'),
                        value: 'Normal',
                    },
                    {
                        text: t('account.disabled'),
                        value: 'Disabled',
                    },
                    {
                        text: t('account.unactivated'),
                        value: 'Unactivated',
                    },
                ],
                filterMultiple: false,
                onFilter: (value, record) => record.status.indexOf(value) === 0,
            },
            ...(userInfo.value.tenant_id == 1? [
                {
                    title: t('account.tenant'),
                    dataIndex: 'tenant_name',
                    key: 'tenant_name',
                    width: 100,
                    resizable: true,
                    // filters: [
                    //     {
                    //         text: 'GOBAO',
                    //         value: 'GOBAO',
                    //     },
                    //     {
                    //         text: 'HEPHA',
                    //         value: 'HEPHA',
                    //     },
                    //     {
                    //         text: 'Corest',
                    //         value: 'Corest',
                    //     },
                    //     {
                    //         text: 'Birk',
                    //         value: 'Birk',
                    //     },
                    // ],
                    // filterMultiple: false,
                    // onFilter: (value, record) => record.tenant_name.indexOf(value) === 0,
                }]:[]
            ),
            {
                title: t('role.roleName'),
                dataIndex: 'role_names',
                key: 'role_names',
                width: 140,
                resizable: true,
            },
            {
                title: t('base.operate'),
                key: 'action',
                fixed: 'right',
                width: 320,
            },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1800,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                // showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const batchSendEmailTable = ref({
        data: [],
        columns: [
            {
                title: t('base.email'),
                dataIndex: 'email',
                key: 'email',
                resizable: true,
            },
            {
                title: t('base.failedReason'),
                dataIndex: 'msg',
                key: 'msg',
                resizable: true,
            },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                // x: 1800,
                y: 280,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const handle = (type, row, key)=>{
        switch(type){
            case 'editAuth': // 授权
                authVisible.value = true    
                rowData.value = row
                role_ids.value = []
                getUserRole(row)
                break;
            case 'authDetail': // 授权详情
                authDetailVisible.value = true
                getUserMenu(row)
                break;
            case 'createAccount': // 创建账号
                visible.value = true
                for(let key in formData){
                    formData[key] = ''
                }
                formData.tenant_admin = false
                form_disabled.value = false
                break;
            case 'invitationRegistration': // 邀请注册
                invitationVisible.value = true
                // for(let key in formData){
                //     formData[key] = ''
                // }
                // formData.tenant_admin = false
                // form_disabled.value = false
                break;
            case 'diasbleAccount': // 禁用账号
                Modal.confirm({
                    title: t('base.tip'),
                    content: t('account.disableTip'),
                    okText: t('base.ok'),
                    cancelText: t('base.cancel'),
                    onOk:()=>{
                        disableAccount(row)
                    },
                });
                break;
            case 'activateAccount': // 激活账号
                Modal.confirm({
                    title: t('base.tip'),
                    content: t('account.activeTip'),
                    okText: t('base.ok'),
                    cancelText: t('base.cancel'),
                    onOk:()=>{
                        activeAccount(row)
                    },
                });
                break;
            case 'showSensitiveData':
                desensitizedData(row, key)
                break;
            case 'hideSensitiveData':
                if(key == 'email'){
                    row.email = row.email_desensitize.value
                    row.show_sensitive_email = true
                } 
                if(key == 'auth_email'){
                    row.auth_email = row.auth_email_desensitize.value
                    row.show_sensitive_auth_email = true
                } 
                break;
            case 'resendEmail':
                Modal.confirm({
                    title: t('base.tip'),
                    content: t('account.resendTip'),
                    okText: t('base.ok'),
                    cancelText: t('base.cancel'),
                    onOk:()=>{
                        resendEmail(row)
                    },
                })
                break;
        }
    }

    const handleInputChange = debounce(()=>{
        table.value.configs.pagination.current = 1
        getAccountList()
    }, 300)
    const handleSearch = ()=>{
        table.value.configs.pagination.current = 1
        getAccountList()
    }

    const handleBlur = ()=>{
        // 兼容如zexin.cai@gobao-ebike.com格式的邮箱校验
        let reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        if(!reg.test(formData.email)){
            message.error(t('base.emailFormatError'))
            return
        }
        checkAccount()
    }
    const handleBatchEmailBlur = ()=>{
        // 兼容如zexin.cai@gobao-ebike.com格式的邮箱校验
        let reg = /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})([;,]\s*([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}))*$/;
        if(!reg.test(invitateFormData.email)){
            message.error(t('base.emailFormatError'))
            return
        }
    }
        
    const changeInput = ()=>{
        if(formData.email == ''){
            form_disabled.value = false
        }
        formData.tenant_id = ''
    }

    const handleChange = (val, key)=>{
        if(key == 'category' && val == 2){
            formData.tenant_admin = false
        }
        console.log(formData,' formData 22222')
    }

    const handleSelectChange = ()=>{
        table.value.configs.pagination.current = 1
        getAccountList()
    }

    // 分页
    const handleChangePagination =  (config, data)=> {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getAccountList()
    }

    // 获取账号列表
    const getAccountList = async ()=>{
        let param = {
            tenant_id: searchForm.tenant_id,
            email: searchForm.email || '',
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await AccountApi.getInstance().getAccountList(param, page_num, page_size)
        if(res.code === 0){
            table.value.configs.loading = false
            res.data.records.forEach(i=>{
                i.category = i.category == 2? t('account.contractManufacturer') : t('account.ordinaryBackEndAccount')
                i.status_val = i.status
                i.status = i.status == 0? t('account.normal') : i.status == 1? t('account.unactivated') : t('account.disabled')
                // i.tenant_name = i.tenant_id == 1? t('base.GOBAO') : i.tenant_id == 0? t('base.HEPHA') : i.tenant_id == 6? t('base.corest') : i.tenant_id == 9? t('base.birk') : '-'
                i.tenant_name = i.tenant_id == undefined? '-' : tenantObj[i.tenant_id]
                i.show_sensitive_email = true
                i.show_sensitive_auth_email = true
                i.create_time = i.create_time.split(' ')[0]
                i.role_names = !i.role_names? '-' : i.role_names.map(i=>{
                    if(i == 'sys:admin') return t('role.admin')
                    if(i == 'sys:default') return t('role.default')
                    if(i == 'sys:test') return t('role.test')
                    if(i == 'sys:tenantDefault') return t('role.tenantDefault')
                    return i
                })
            })
            console.log(res.data.records, 'res.data.records')
            table.value.data = res.data.records
            table.value.configs.pagination.total = res.data.total
        }else{
            message.error(res.msg || res.message)
        }
    }

    const vaild = ()=>{
        let regEmail = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
        // let regPsd = /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{6,10}$/
        let regPsd = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,16}$/
        if(!formData.email){
            message.error(t('account.emailAddr') +' '+ t('base.noEmpty'))
            return false
        }else if(!regEmail.test(formData.email)){
            message.error(t('base.emailFormatError'))
            return false
        }else if(!formData.category){
            message.error(t('account.accountType') +' '+ t('base.noEmpty'))
            return false
        }else if(userInfo.value.tenant_id == 1 && user_category2.value.length > 0 && formData.tenant_id === ''){
            message.error(t('account.tenant') +' '+ t('base.noEmpty'))
            return false
        }else if(formData.first_name.trim() === '' && !form_disabled.value){
            message.error(t('account.firstName') +' '+ t('base.noEmpty'))
            return false
        }else if(formData.last_name.trim() === '' && !form_disabled.value){
            message.error(t('account.lastName') +' '+ t('base.noEmpty'))
            return false
        }else if(formData.company.trim() === '' && !form_disabled.value){
            message.error(t('account.companyName') +' '+ t('base.noEmpty'))
            return false
        }else if(formData.mobile === '' && !form_disabled.value){
            message.error(t('account.telephone') +' '+ t('base.noEmpty'))
            return false
        }else if(formData.password === '' && !form_disabled.value){
            message.error(t('account.password') +' '+ t('base.noEmpty'))
            return false
        }else if(formData.confirm_password === '' && !form_disabled.value){
            message.error(t('account.confirmPsw') +' '+ t('base.noEmpty'))
            return false
        }else if(formData.confirm_password != formData.password){
            message.error(t('account.pswTip'))
            return false
        }else if(formData.confirm_password !== '' && formData.password !== '' && !regPsd.test(formData.password)){
            // message.error(t('login.passwordFormat'))
            message.error({
                content: t('login.passwordFormat'),
                duration: 3,
            })
            return
        }

        return true
    }

    const batchEmailVaild = ()=>{
        let reg = /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})([;,]\s*([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}))*$/;
        if(!invitateFormData.email){
            message.error(t('account.emailAddr') +' '+ t('base.noEmpty'))
            return false
        }else if(!reg.test(invitateFormData.email)){
            message.error(t('base.emailFormatError'))
            return false
        }
        return true
    }

    // 创建账号
    const createAccount = async()=>{
        if(!vaild()) return

        let param = {
            ...formData,
            tenant_id: userInfo.value.tenant_id == 1 && user_category2.value.length > 0? formData.tenant_id : userInfo.value.tenant_id,
            tenant_admin: formData.tenant_admin? 0 : 1, // 0是，1否
            create_flag: form_disabled.value? 1 : 0,  // 0:创建   1：添加
        }
        confirmLoading.value = true
        let res = await AccountApi.getInstance().createAccount(param)
        if(res.code === 0){
            visible.value = false
            confirmLoading.value = false
            if( operateType.value == 'edit'){
                notification.success({
                    message: t('base.editSuccessMsg'),
                    description: t('account.editSuccessTip'),
                    placement:'top',
                    duration: 4,
                })
            }else{
                createTipVisible.value = true
            }

            getAccountList()
            
        }else{
            message.error(res.msg || res.message)
            confirmLoading.value = false
        }
    }
    // 邀请注册
    const invitationRegistration = async()=>{
        if(!batchEmailVaild()) return

        let param = {
            emails: invitateFormData.email,
            language: invitateFormData.lang,
        }
        invitateConfirmLoading.value = true
        let res = await AccountApi.getInstance().invitateRegistrateAccount(param)
        if(res.code === 0){
            
            invitateConfirmLoading.value = false
            invitationVisible.value = false
            
            batchSendEmailTable.value.data = res.data.failedEmails

            invitationTotal.value = res.data.successEmails.length + res.data.failedEmails.length || 0
            invitationSuccess.value = res.data.successEmails.length || 0
            invitationFailed.value = res.data.failedEmails.length  || 0

            batchTipVisible.value = true
            // if( operateType.value == 'edit'){
            //     notification.success({
            //         message: t('base.editSuccessMsg'),
            //         description: t('account.editSuccessTip'),
            //         placement:'top',
            //         duration: 4,
            //     })
            // }else{
            //     createTipVisible.value = true
            // }
            getAccountList()
            
        }else{
            message.error(res.msg || res.message)
            invitateConfirmLoading.value = false
        }
    }

    // 邀请注册
    const getLangList = async() => {
        let res = await AccountApi.getInstance().getLangList()
        if(res.code === 0){
            langOptions.value = res.data.map(item=>{
                return {
                    label:item.langShow,
                    value:item.langCode
                }
            })
            
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 用户-角色列表
    const getUserRole = async(row)=>{
        let param = {
            menu_types:[2],
            tenant_id: row.tenant_id,
            display: 0,
        }
        let res = await RoleApi.getInstance().getUserRole(param, row.user_id)
        if(res.code === 0){
            treeData.value = []
            checkedKeys.value = []
            let arr = ['sys:admin','sys:default','sys:test']
            sys_role_arr.value = []
            res.data.forEach(i=>{
                if(userInfo.value.tenant_id !== 1 && arr.includes(i.role_name)){
                    sys_role_arr.value.push(i.id) 
                }else{
                    treeData.value.push({
                        key: i.id,
                        disabled:i.diff_flag == true,
                        title: i.role_name == 'sys:tenantDefault'? t('role.tenantDefault') : i.role_name == 'sys:admin'? t('role.admin') : i.role_name == 'sys:default'? t('role.default') : i.role_name == 'sys:test'? t('role.test') : i.role_name,
                        children: i.children.length > 0 ? i.children.map(j=>({
                            key: `${i.id}-${j.id}`,
                            title: t(j.menu_name),
                            checkable:false,
                        })) : []
                    })
                    if(i.bind_flag){
                        checkedKeys.value.push(i.id)
                    }
                }
            })
            console.log(treeData.value, 'treeData',checkedKeys.value)
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 授权-新增用户绑定角色
    const bindRole = async()=>{
        // console.log(role_ids.value, sys_role_arr.value, 'vvvvv')
        if(checkedKeys.value.length == 0){
            message.error(t('base.pleaseSelectRole'))
            return
        }
        
        let param = {
            user_ids: [rowData.value.user_id],
            role_ids: checkedKeys.value.concat(sys_role_arr.value),
            tenant_id: rowData.value.tenant_id
        }
        let res = await RoleApi.getInstance().addUserBindRole(param)
        if(res.code === 0){
            authVisible.value = false
            getAccountList()
            
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取用户关联的菜单
    const getUserMenu = async(row)=>{
        let param = {
            menu_types: [2],
        }
        let res = await RoleApi.getInstance().getUserMenu(param, row.user_id, row.tenant_id)
        if(res.code === 0){
            user_auth_label.value = res.data.map(i=> t(i.menu_name))
        }else{
            message.error(res.msg || res.message)
        }
    } 

    // 激活账号
    const activeAccount = async(row)=>{
        let res = await AccountApi.getInstance().activeAccount(row.id, row.user_id)
        if(res.code === 0){
            getAccountList()
            
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 禁用账号
    const disableAccount = async(row)=>{
        let res = await AccountApi.getInstance().disableAccount(row.id)
        if(res.code === 0){
            getAccountList()
            
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 检查账号
    const checkAccount = async()=>{
        let param = {
            email: formData.email,
            tenant_id: userInfo.value.tenant_id,
        }
        let res = await AccountApi.getInstance().checkAccount(param)
        if(res.code === 0){
            form_disabled.value = res.data
            operateType.value = res.data? 'edit' : 'add'

            if(res.data){
                Modal.confirm({
                    title: t('base.tip'),
                    content: t('account.editTip'),
                    okText: t('base.ok'),
                    centered:true,
                    cancelText: t('base.cancel'),
                    onOk:()=>{},
                    onCancel:()=>{
                        visible.value = false
                    },
                })
            }
            
        }else if(res.code == 1241){
            Modal.confirm({
                title: t('base.tip'),
                content: res.msg,
                okText: t('base.ok'),
                cancelText: t('base.cancel'),
                onOk:()=>{
                    visible.value = false
                },
            });
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 重新发送邮件
    const resendEmail = async(row)=>{
        let res = await LoginApi.getInstance().resendEmail(row.user_id)
        if(res.code == 0){
            message.success(t('base.sendSucceeded'))
            
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 重置
    const reset = ()=>{
        for(let key in formData){
            formData[key] = ''
        }
    }

    // 取消
    const back = ()=>{
        visible.value = false
    }
    const invitationBack = ()=>{
        invitationVisible.value = false
    }

    const handleMenuTreeCheck = (checkedKeys, info) => {
        console.log('checkedKeys', checkedKeys)
        console.log('info', info)

        role_ids.value = checkedKeys
    }

    // 脱敏数据
    const desensitizedData = async (row, key)=>{
        let param = {
            request_param: key == 'email'? JSON.stringify(row.email_desensitize) : JSON.stringify(row.auth_email_desensitize),
        }
        let res = await AdvancedFunApi.getInstance().desensitizedData(param, row.id)
        if(res.code === 0){
            message.success(t('base.success'))
            if(key == 'email'){
                row.email = res.data
                row.show_sensitive_email = false
            } 
            if(key == 'auth_email'){
                row.auth_email = res.data
                row.show_sensitive_auth_email = false
            } 
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取当前用户是否能分配角色权限
    const getUserHasAssignRoleAuth = async()=>{
        let param = {
            role_ids: userInfo.value.role.split(',').map(i=>{return Number(i)}),
        }
        let res = await RoleApi.getInstance().getUserHasAssignRoleAuth(param, userInfo.value.id)
        if(res.code === 0){
            userHasAssignRoleAuth.value = res.data

            table.value.columns[table.value.columns.length - 1].width = userHasAssignRoleAuth.value? 320 : 170
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 查询用户租户下的角色列表
    const getTenantRoleList = async()=>{
        let param = {
            tenant_id: userInfo.value.tenant_id,
        }
        let res = await RoleApi.getInstance().getTenantRoleList(param, userInfo.value.id)
        if(res.code === 0){
            user_category.value = res.data.filter(i=> i.category === 0 || i.category === -1)
            user_category2.value = res.data.filter(i=> i.category === -1)
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取租户列表
    const getTenantList = async()=>{
        let param = {
            limit_size: 100,
        }
        let res = await AdvancedFunApi.getInstance().getAllTenant2(param)
        if(res.code === 0){
            tenantOptions.value = res.data.map(item => ({
                label: item.tenant_name,
                value: item.tenant_id,
            }))

            searchTenantOptions.value = res.data.map(item => ({
                label: item.tenant_name,
                value: item.tenant_id,
            }))
            searchTenantOptions.value.unshift({
                label: t('access.allTenant'),
                value: null,
            })

            res.data.forEach(i=>{
                tenantObj[i.tenant_id] = i.tenant_name
            })
        }
    }
    

    onMounted(async ()=>{
        getTenantList()
        await getUserHasAssignRoleAuth()
        getAccountList()
        getTenantRoleList()

        getLangList()
    })
</script>

<style lang="scss" scoped>
.operate_btn{
    margin-top: 0rem;
    margin-bottom: .625rem;
}

.query_box{
    margin-top: 1.875rem;
    margin-bottom: .625rem;

    .query_field{
        display: inline-block;
        margin-right: .625rem;
        width: 12.5rem;
    }
}

.form{

    .form_item{
        margin-bottom: .9375rem;

        .form_item_label{
            font-size: 1rem;
            font-weight: 600;
        }

        .required{
            color: red;
        }
    }

    .form_item_flex{
        display: flex;

        .form_item_left{
            display: flex;
            flex: 1;
            flex-direction: column;
            margin-right: .9375rem;
        }

        .form_item_right{
            display: flex;
            flex: 1;
            flex-direction: column;
        }
    }
}

.table_title{
    margin: 1.875rem 0 1.25rem;
    text-align: center;
    font-size: 1.5rem;
    font-weight: 700;
}

.chart_block{
    margin: 2.8125rem 0 .9375rem;

    .chart{
        display: flex;

        #torqueChart,
        #torqueChart2,
        #torqueChart3,
        #torqueChart4,
        #torqueChart5,
        #torqueChart6,
        #torqueChart7,
        #torqueChart8{
            margin-top: .625rem;
            margin-right: 3.125rem;
            padding: .625rem;
            width: 31.25rem;
            background: #fff;
            border-radius: .5625rem;
        }
    }
}

.back{
    display:inline-block;
    margin-bottom: 1.25rem;
    font-size: 1.125rem;
    font-weight: 600;
    color: #1226AA;
    cursor: pointer;
    margin-right: .625rem;
}


.createBtnDiv{
    text-align: center;

    .createBtn{
        margin:1.25rem 0 .625rem;
        width:12.5rem;
        text-align: center;
    }
}

.createTip{
    margin: 1.25rem 0;
    padding: .625rem 2.5rem;
    background: #f6f6f6;
    border-radius: .625rem;

    .tip_title{
        margin-left: -1.25rem;
        font-weight: 700;
        font-size: 1.0625rem;

        .tip_img{
            margin-top: -0.25rem;
        }
    }
    .tip_text{
        margin: .625rem 0;
        color: #666;
        font-size: .8125rem;
    }
}

.createSuccessTip{
    margin: 1.25rem 0;
    padding: .625rem 2.5rem;
    background: #f6f6f6;
    border-radius: .625rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .tip_title{
        margin-left: -1.25rem;
        font-weight: 700;
        font-size: 1.25rem;

        .tip_img{
            margin-top: -0.25rem;
        }
    }
    .tip_text{
        margin: .625rem 0;
        color: #666;
        font-size: .8125rem;
    }
}


::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: .375rem 1rem;
}

// 子表格的表体行样式
::v-deep .subTableBg{
    background: #f6f6f6 !important;
}

::v-deep .ant-tree-list{
    max-height: 37.5rem !important;
    overflow-y: scroll;
}
</style>